import type { RouteRecordRaw } from 'vue-router';

export default {
  path: 'baremetal/:server_id',
  component: () => import('@/views/dashboard/baremetal/server/root.vue'),
  redirect: () => ({ name: 'server/overview' }),
  children: [
    {
      path: 'overview',
      name: 'server/overview',
      component: () => import('@/views/dashboard/baremetal/server/overview.vue'),
    },
  ],
} satisfies RouteRecordRaw;
